import React, { useMemo, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import type { Chart, ChartOptions, TooltipModel } from 'chart.js';
import type { AnalyticsTooltipEntry } from 'actions/analyticActions';

interface DoughnutOption {
  name: string;
  data: AnalyticsTooltipEntry[];
}

export interface DoughnutGraphicProps {
  data: {
    labels: string[];
    datasets: Array<{
      data: number[];
      backgroundColor: string[] | readonly string[];
      borderWidth: number;
    }>;
  };
  count: number;
  options: DoughnutOption[];
}

export const DoughnutGraphic = ({ data, count, options }: DoughnutGraphicProps) => {
  const [option, setOption] = useState<DoughnutOption | null>(null);

  const doughnutOptions = useMemo(
    () => ({
      cutout: 82,
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        legend: { display: false },
        tooltip: {
          enabled: false,
          external: ({ tooltip }: { chart: Chart; tooltip: TooltipModel<'doughnut'> }) => {
            setOption(tooltip.opacity ? options[tooltip.dataPoints[0].dataIndex] : null);
          },
        },
      },
    }),
    [options]
  );

  return (
    <div className="doughnut">
      <div className="doughnut__info">
        <span>{count}</span>
        Total rejections
      </div>
      <Doughnut data={data} options={doughnutOptions as ChartOptions<'doughnut'>} />
      <div className="doughnut__tooltip">
        {!!option && (
          <div>
            <div className="title">{option.name}</div>
            {option.data.map(el => (
              <div key={el.name}>
                <span>{el.name}</span>
                <span>{el.data}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
